const currentDomainName = () => {
  if (typeof window !== `undefined`) {
    const temp = window.location.hostname
      .split(':')[0]
      .split('.')
      .reverse()
    return `.${temp[1]}.${temp[0]}`
  }
}

const getCookie = key => {
  var b = document.cookie.match('(^|[^;]+)\\s*' + key + '\\s*=\\s*([^;]+)')
  return b ? b.pop() : ''
}

const myDomain = currentDomainName()

const createCookie = (
  sKey,
  sValue,
  vEnd,
  sPath = '/',
  sDomain = myDomain,
  bSecure = false
) => {
  if (!sKey || /^(?:expires|max-age|path|domain|secure)$/.test(sKey)) {
    return
  }
  let sExpires = ''
  if (vEnd) {
    switch (typeof vEnd) {
      case 'number':
        sExpires = `; max-age=${vEnd}`
        break
      case 'string':
        sExpires = `; expires=${vEnd}`
        break
      case 'object':
        if (vEnd.hasOwnProperty('toGMTString')) {
          sExpires = `; expires=${vEnd.toGMTString()}`
        }
        break
    }
  }
  document.cookie = `${escape(sKey)}=${escape(sValue)}${sExpires}${
    sDomain ? `; domain=${sDomain}` : ''
  }${sPath ? `; path=${sPath}` : ''}${bSecure ? '; secure' : ''}`
}

export { createCookie, getCookie }
